import { Mask } from 'utils/mask';

define((require) => {
    'use strict';
    require('jQuery');
    const BInput = require('toolkit/b-input/b-input');

    return BInput.extend('b-masked-input', {
        init() {
            // eslint-disable-next-line prefer-rest-params
            BInput.fn.init.apply(this, arguments);

            if (this._hasMask()) {
                this._applyMask();
            }
        },

        setValue(value) {
            if (this._hasMask()) {
                value = this._makeMaskedValue(value);
            }

            BInput.fn.setValue.call(this, value);
        },

        getValue() {
            if (this._hasMask()) {
                return this.$el.cleanVal();
            }

            // eslint-disable-next-line prefer-rest-params
            return BInput.fn.getValue.apply(this, arguments);
        },

        _hasMask() {
            const {
                props: { mask, maskOptions, maskPattern } = {},
            } = this.data;
            return mask || maskOptions || maskPattern;
        },

        _applyMask(cleanValue = '') {
            const props = this.data.props || {};

            const pattern = Mask.patterns[props.maskPattern];
            if (pattern) {
                const { getMaskByValue, maskOptions } = pattern;
                this.$el.mask(getMaskByValue(cleanValue), maskOptions);
            } else {
                const { mask, maskOptions } = props;
                this.$el.mask(mask, maskOptions);
            }
        },

        _makeMaskedValue(cleanValue) {
            this._applyMask(cleanValue);
            return this.$el.masked(cleanValue);
        },
    });
});
